module.exports = __webpack_public_path__ + "img/route.a1fdb077.svg";